import React, { useMemo } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faThumbtack } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '@mui/material/styles';
import { Box, Chip, Typography } from "@mui/material";
import { useLocation } from 'react-router-dom';
import { convertToDateWithHHMM } from "../../medias/utils.js";

const BoxMedia = ({ media, children, match, onTagClick }) => {
  const { isPin } = media;
  const theme = useTheme();
  const location = useLocation();

  const selectedTags = useMemo(
    () => new URLSearchParams(location.search).get('tags')?.split(',') || [],
    [location.search]
  );

  const resolvedTags = useMemo(() => {
    if (!media?.tags?.length || !match?.tags?.length) {
      return [];
    }

    return media.tags
      .map((tagId) => match.tags.find((tag) => tag._id === tagId))
      .filter(Boolean);
  }, [media?.tags, match?.tags]);

  return (
    <Box
      sx={{
        position: 'relative',
        padding: '16px',
        ...(isPin && {
          borderRadius: '20px',
          backgroundColor: `${theme.palette.pinBox.mainBackground}`,
          margin: '0 20px',
          marginBottom: '30px',
        }),
      }}
    >
      {isPin && (
        <Box
          sx={{
            position: 'absolute',
            top: '-15px',
            right: '-15px',
            width: '40px',
            height: '40px',
            borderRadius: 40,
            border: `4px solid ${theme.palette.pinBox.mainBackground}`,
            background: `${theme.palette.media.lightgrey}`,
            transform: 'rotate(30deg)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <FontAwesomeIcon icon={faThumbtack} />
        </Box>
      )}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 0,
        }}
      >
        {!isPin && (
          <>
            <Box
              sx={{
                width: '40px',
                height: '40px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <FontAwesomeIcon icon={faClock} />
            </Box>
            <Box
              sx={{
                padding: '8px',
              }}
            >
              <Typography variant="h3" sx={{ lineHeight: 1.5 }}>
                {convertToDateWithHHMM(media.displayDate ?? media.creation)}
              </Typography>
            </Box>
          </>
        )}
      </Box>

      {children}

      {resolvedTags.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.5 }}>
          {resolvedTags.map((tag) => {
            const isSelected = selectedTags.includes(tag._id);

            return (
              <Chip
                key={tag._id}
                label={tag.name}
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onTagClick?.(tag._id);
                }}
                sx={{
                  backgroundColor: isSelected ? '#3f51b5' : '#f1f1f1',
                  color: isSelected ? '#fff' : '#333',
                  borderRadius: '16px',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: isSelected ? '#303f9f' : '#e0e0e0',
                  },
                }}
              />
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default BoxMedia;